import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentConfig } from '../../interfaces/environment.interface';
import {
  OperatorUsersResponse,
  ProjectManagers,
  SaveUserResponse,
  UpdateUserResponse,
  UpdateUsersStatusPayload,
  UpdateUsersStatusResponse,
  UserPayload,
  UsersResponse,
} from '../../interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly _baseUrl = this._env.environment.pureSpectrum.url;
  constructor(
    private _http: HttpClient,
    @Inject('ENV') private _env: EnvironmentConfig
  ) {}

  getUsers() {
    return this._http.get<UsersResponse>(`${this._baseUrl}/users`);
  }

  getToken(userId: number, userStatus: boolean) {
    return this._http.get<{ token: string }>(
      `${this._baseUrl}/getUserToken/${userId}/${userStatus}`
    );
  }

  updateUserStatus(userId: number, payload: UpdateUsersStatusPayload) {
    return this._http.put<UpdateUsersStatusResponse>(
      `${this._baseUrl}/updateuserstatus/${userId}`,
      payload
    );
  }

  saveUser(payload: UserPayload) {
    return this._http.post<SaveUserResponse>(`${this._baseUrl}/user`, payload);
  }

  updateUser(payload: UserPayload, userId: number) {
    return this._http.put<UpdateUserResponse>(
      `${this._baseUrl}/user/${userId}`,
      payload
    );
  }

  getAllOperatorUser(apiUsers = true) {
    return this._http.get<OperatorUsersResponse>(
      `${this._baseUrl}/operator-users?apiUsers=${apiUsers}`
    );
  }

  getAllBuyerUser(companyId: number, apiUsers = true) {
    return this._http.get<ProjectManagers[]>(
      `${this._baseUrl}/companies/${companyId}/users?apiUsers=${apiUsers}`
    );
  }
}
